module.exports = __webpack_public_path__ + "img/P150T_weapon_11.566754fe.png";